import log from '@uwm/logger';

const parentOrigin: string = (() => {
    try {
        const ancestors = globalThis.location?.ancestorOrigins;
        if (ancestors && ancestors.length > 0) return ancestors[0];
        if (typeof document !== 'undefined' && document.referrer) {
            return new URL(document.referrer).origin;
        }
    } catch (e) {
        log.warn('[UWM] Failed to determine parent origin, defaulting to globalThis.location.origin', e);
    }
    return globalThis.location?.origin ?? '*';
})();

export const sendMessageToParent = (payload: Record<string, unknown>): void => {
    const detail = {
        command: 'UwmEvent',
        payload,
    };

    window.parent.postMessage({detail}, parentOrigin);
    log.info(`[UWM] → ${JSON.stringify(payload)}`);
};
